import { cn } from "@/lib/cn";

type Variant = "go" | "ghost" | "secondary" | "danger";
type Size = "sm" | "md";

const variants: Record<Variant, string> = {
  go: "bg-acc text-on-acc hover:bg-acc-hover",
  ghost: "bg-bg2 text-txt2 border border-line hover:bg-panel-hover hover:text-txt",
  secondary: "bg-bg3 text-txt2 border border-line hover:bg-panel-hover",
  danger: "border border-red/40 bg-[var(--red-soft)] text-red hover:bg-red/15",
};

const sizes: Record<Size, string> = {
  sm: "px-3 py-1.5 text-[12px]",
  md: "px-[18px] py-2.5 text-[13px]",
};

export function Button({
  variant = "ghost",
  size = "md",
  className,
  children,
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
}) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-xs font-semibold transition active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-40",
        "hover:-translate-y-px",
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
